import { LiliPlan } from '@Pages/happyFlowPages/planSelection/types';
import { RoutesMap } from '@Router/router.types.ts';

export enum AppStateTypes {
  READY = 'READY',
  PRELOAD = 'PRELOAD',
  LOADING = 'LOADING',
}

export enum OnboardingFlowIdentifier {
  DIRECT = 'DIRECT',
  DIRECT_MULTI_BUSINESS = 'MULTI_BUSINESS',
  PARTNER_CONNECT = 'PARTNER_CONNECT',
  PARTNER_EMBEDDED = 'PARTNER_EMBEDDED',
  UBO = 'UBO',
  AUTHORIZED_USER = 'AUTHORIZED_USER',
}

export enum OnboardingFlowType {
  PARTNER = 'PARTNER',
  EMBEDDED = 'EMBEDDED',
  REGULAR = 'REGULAR',
}

export enum AbTestFlowIds {
  CONTROL = 'CONTROL ',
}

export enum DeviceType {
  IOS = 'ios',
  ANDROID = 'android',
  UNKNOWN = 'unknown',
}

export interface RouterData {
  prevRoute: string;
  currentRoute: string;
}
export interface IOnboardingSlice {
  onboardingSlice: {
    navigationStack: RoutesMap[];
    pickupWhereLeftNavigationStack: RoutesMap[];
    appState: AppStateTypes;
    editMode: boolean;
    currentPageIndex: number;
    progressValue: number;
    flowType: OnboardingFlowType;
    isFromLiliApp: boolean;
    isPartnerFlow: boolean;
    partnerName: string;
    onboardingFlowIdentifier: OnboardingFlowIdentifier;
    abTestFlowId: AbTestFlowIds;
    onboardingStartTime: number;
    deviceType: DeviceType;
    partnerToken: string;
    customerKey: string;
    customerId: string;
    authorizedUserId: string;
    referralCode: string;
    sourcePlatform: string;
    adSource: string;
    isLoginProcessFinished: boolean;
    isPlanActivelySelected: boolean;
    routerData: RouterData;
    deviceId: string;
    isAnnualPlanSelected: boolean;
    preSelectedAnnualPlan: boolean;
    selectedPlan?: LiliPlan;

    /** Setters */
    setQueryParamValue: (key: string, value: string) => void;
    setAppState: (value: AppStateTypes) => void;
    setEditMode: (value: boolean) => void;
    setCurrentPageIndex: (value: number) => void;
    setProgressValue: (value: number) => void;
    setFlowType: (value: OnboardingFlowType) => void;
    setAbTestFlowId: (value: AbTestFlowIds) => void;
    setIsPartnerFlow: (value: boolean) => void;
    setPartnerName: (value: string) => void;
    setOnboardingIdentifier: (value: OnboardingFlowIdentifier) => void;
    setIsLoginProcessFinished: (value: boolean) => void;
    setNavigationStack: (value: RoutesMap[]) => void;
    setPickupWhereLeftNavigationStack: (value: RoutesMap[]) => void;
    setPlanActivelySelected: (value: boolean) => void;
    setRouterData: (value: RouterData) => void;
    setDeviceId: (value: string) => void;
    setPreSelectedAnnualPlan: (value: boolean) => void;
    setIsAnnualPlanSelected: (value: boolean) => void;
    setSelectedPlan: (value: LiliPlan) => void;
    /** Getters */
    getOnboardingData: () => IOnboardingSlice['onboardingSlice'];
    getIsEmbedded: () => boolean;
  };
}
